import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { isAuthenticated } from '@/libs/Auth'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'tickets',
    // src/modules/tickets/
    component: () => import(/* webpackChunkName: "tickets" */ '@tickets/index.vue'),
    meta: { authRequired: true }
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    // src/modules/monitoring/
    component: () => import(/* webpackChunkName: "monitoring" */ '@monitoring/index.vue'),
    meta: { authRequired: true }
  },
  // {
  //   path: '/advanced-search',
  //   name: 'advanced-search',
  //   component: () => import(/* webpackChunkName: "advanced-search" */ '@advanced-search/index.vue'),
  //   meta: { authRequired: true }
  // },
  {
    path: '/failed',
    name: 'Failed',
    // component: AuthFailed,
    component: () => import(/* webpackChunkName: "auth-failed" */ '@/views/AuthFailed.vue'),
    meta: { authRequired: false }
  },
  {
    path: '/logout',
    name: 'Logout',
    // component: LogoutPage,
    component: () => import(/* webpackChunkName: "logout-page" */ '@/views/LogoutPage.vue'),
    meta: { authRequired: false }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to?.meta?.authRequired) {
    const shouldProceed = await isAuthenticated()
    if (!shouldProceed) {
      next({ name: 'Failed' })
    } else {
      next()
    }
  } else {
    if (to.name) {
      next()
    } else {
      next('/')
    }
  }
})

if (process.env.NODE_ENV === 'development') {
  router.addRoute(
    {
      path: '/wip_michel',
      name: 'wip_michel',
      component: () => import(/* webpackChunkName: "wipMichel" */ '@/_wip/michel/TestSnacks.vue'),
      meta: { authRequired: true }
    }
  )
}

export default router
